const defaultCurrencyFormatOptions = {
  style: "currency",
  currency: "CAD",
  currencyDisplay: "narrowSymbol",
};

export const currencyFormatterFactory = (intl, options = {}) => {
  const mergedOptions = { ...defaultCurrencyFormatOptions, ...options };
  return (value) => intl.formatNumber(value, mergedOptions);
};

export const convertBlankOptionToNull = (value) => {
  return  typeof value === 'string' && value.trim() === "" ? null : value;
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/utils.js